import { UserType } from '@/data/models/user.model';
import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/fattorini/Fattorini.vue'),
		meta: {
			title: 'fattorini',
			acl: 'section.fattorini'
		}
	},
	{
		path: 'new',
		component: () => import('@/views/utenti/utente/UtenteDetail.vue'),
		meta: {
			title: 'new-fattorino',
			acl: 'section.fattorini',
			utype: UserType.FATTORINO
		}
	},
	{
		path: ':utenteid/edit',
		component: () => import('@/views/utenti/utente/UtenteDetail.vue'),
		props: true,
		meta: {
			title: 'edit-fattorino',
			acl: 'section.fattorini',
			utype: UserType.FATTORINO
		}
	}
];

export default routes;